import gql from 'graphql-tag';

export const CompanyCertificationListQuery = gql`
	query CompanyCertificationListQuery(
		$first: Int
		$cursor: String
		$filter: SearchByNameInput
	) {
		entities: companyCertifications(
			first: $first
			after: $cursor
			filter: $filter
		) {
			edges {
				node {
					id
					name
					akas
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;


